/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { isMobile } from 'react-device-detect'

// icon
import GuideCharacter from '@assets/images/popup/guide_character.png'
import SpeechBubble from '@assets/images/popup/speech_bubble.png'
import { GmoneyIco } from '@shared/Icon/MoneyIcon'

// css
import { ModalBg } from '@styles/base.style'
import { Button, PopupBtnStyle, ButtonWrap } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { GuideWrap, GuideImgWrap } from '../index.style'


const GuideNoticePopup: React.FC = props => {
  const { globalStore, userStore, routerStore } = useRootStore()
  const { visibleGuideNoticePopup, getGuideBonus } = globalStore

  const guideBonus = getGuideBonus().toLocaleString()

  const beforeClose = async () => {
    await userStore.setGuidPopupDisplayed()

    const { settlementSupport } = userStore
    settlementSupport.showGuidePopup = false
    userStore.setSettlementSupport(settlementSupport)

    globalStore.setVisibleGuideNoticePopup(false)
  }

  const onCloseModal = async () => {
    await beforeClose()
  }

  const onClickToGuide = async () => {
    await beforeClose()
    if (isMobile) {
      routerStore.push('/guide')
    } else {
      globalStore.setVisibleGuide(true)
    }
  }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleGuideNoticePopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="custom-dialog character-popup"
        wrapClassName="guide-notice-popup first-guide-popup"
      >
        <GuideWrap className="guide-notice">
          <div className="guide-box complete">
            신규 회원님! 퀵 가이드를 정독하시면<br />
            보너스 머니 <span className="point-txt point-color--yellow--modal">{guideBonus}<GmoneyIco /></span> 를 받으실 수 있습니다.
          </div>
        </GuideWrap>

        <ButtonWrap className="custom-dialog-wrap ">
          <Button onClick={onCloseModal} css={PopupBtnStyle} className="two-button cancel dialog">
            취소
          </Button>
          <Button onClick={onClickToGuide} css={PopupBtnStyle} className="two-button dialog money">
            30,000<GmoneyIco /> 받기
          </Button>
        </ButtonWrap>

        <ModalBg onClick={onCloseModal} />

        {/* 캐릭터 영역 */}
        <GuideImgWrap>
          <img src={GuideCharacter} alt="캐릭터" className="guide-character" />
          <span className="speech-bubble-wrap ">
            <img src={SpeechBubble} alt="말풍선" className="speech-bubble" />
            <p className="speech-bubble-txt">
              승부사온라인에 오신걸
              <br />
              환영합니다!
            </p>
          </span>
        </GuideImgWrap>
      </Modal>
    </Fragment>
  )
}

export default observer(GuideNoticePopup)
